import { Garden, Controller, Sensor, Company, User, DashboardStats, WeatherData, Schedule, Trigger, MQTTServer, LNSServer, IrrigationEvent } from '@/types';

export const mockMQTTServers: MQTTServer[] = [
  {
    id: 'mqtt-1',
    name: 'MQTT Principal',
    broker: 'mqtt.irrigo.local',
    port: 1883,
    useTLS: false,
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-10'),
  },
  {
    id: 'mqtt-2',
    name: 'MQTT Cloud (TLS)',
    broker: 'mqtt.irrigo.cloud',
    port: 8883,
    username: 'irrigo_user',
    useTLS: true,
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-02-15'),
  },
];

export const mockLNSServers: LNSServer[] = [
  {
    id: 'lns-1',
    name: 'ChirpStack Madrid V4',
    type: 'chirpstack_v4',
    serverUrl: 'https://chirpstack.irrigo.local',
    apiKey: 'cs_api_key_xxxxx',
    applicationId: 'app-irrigo-madrid',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-15'),
  },
  {
    id: 'lns-2',
    name: 'ChirpStack Barcelona V3',
    type: 'chirpstack_v3',
    serverUrl: 'https://chirpstack-bcn.irrigo.local',
    apiKey: 'cs_api_key_yyyyy',
    applicationId: 'irrigo-bcn-app',
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-03-01'),
  },
];

export const mockCompanies: Company[] = [
  {
    id: '1',
    name: 'Jardines Municipales Madrid',
    cif: 'A28123456',
    address: 'Calle Gran Vía 1, Madrid',
    phone: '+34 91 123 4567',
    email: 'info@jardinesmadrid.es',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-06-01'),
  },
  {
    id: '2',
    name: 'Ayuntamiento de Sevilla',
    cif: 'P4109100J',
    address: 'Plaza Nueva 1, Sevilla',
    phone: '+34 95 456 7890',
    email: 'parques@sevilla.es',
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-05-15'),
  },
  {
    id: '3',
    name: 'Parques y Jardines Barcelona',
    cif: 'Q0801234F',
    address: 'Passeig de Gràcia 25, Barcelona',
    phone: '+34 93 234 5678',
    email: 'jardins@barcelona.cat',
    createdAt: new Date('2024-03-10'),
    updatedAt: new Date('2024-06-10'),
  },
];

export const mockUsers: User[] = [
  {
    id: '1',
    email: 'superadmin@irrigo.es',
    name: 'Carlos García',
    password: 'admin123',
    role: 'superadmin',
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: '2',
    email: 'admin@jardinesmadrid.es',
    name: 'María López',
    password: 'madrid123',
    role: 'company_admin',
    companyId: '1',
    createdAt: new Date('2024-01-20'),
    updatedAt: new Date('2024-03-15'),
  },
  {
    id: '3',
    email: 'admin@sevilla.es',
    name: 'Pedro Martínez',
    password: 'sevilla123',
    role: 'company_admin',
    companyId: '1',
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-04-20'),
  },
  {
    id: '4',
    email: 'admin@sevilla.es',
    name: 'Ana Fernández',
    password: 'sevilla123',
    role: 'company_admin',
    companyId: '2',
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-05-10'),
  },
  {
    id: '5',
    email: 'admin@barcelona.cat',
    name: 'Jordi Puig',
    password: 'barcelona123',
    role: 'company_admin',
    companyId: '3',
    createdAt: new Date('2024-03-15'),
    updatedAt: new Date('2024-06-01'),
  },
];

export const mockControllers: Controller[] = [
  {
    id: '1',
    name: 'Controlador Zona Norte',
    model: 'UC512',
    deviceEUI: 'A8404136C1842D5E',
    gardenId: '1',
    coordinates: { lat: 40.4232, lng: -3.6898 },
    communicationType: 'chirpstack',
    lnsConfig: {
      serverId: 'lns-1',
    },
    status: 'online',
    lastSeen: new Date(),
    battery: 85,
    valves: [
      { id: 'v1', controllerId: '1', channel: 1, name: 'Válvula Césped', status: 'closed' },
      { id: 'v2', controllerId: '1', channel: 2, name: 'Válvula Arbustos', status: 'open', lastAction: new Date() },
    ],
    assignedSensorIds: ['1', '2'],
    createdAt: new Date('2024-02-01'),
    updatedAt: new Date('2024-06-15'),
  },
  {
    id: '2',
    name: 'Controlador Zona Sur',
    model: 'UC511',
    deviceEUI: 'A8404136C1842D5F',
    gardenId: '1',
    coordinates: { lat: 40.4210, lng: -3.6880 },
    communicationType: 'mqtt',
    mqttConfig: {
      serverId: 'mqtt-1',
      subscriptionTopic: 'irrigo/controllers/A8404136C1842D5F/rx',
      publishTopic: 'irrigo/controllers/A8404136C1842D5F/tx',
    },
    status: 'online',
    lastSeen: new Date(Date.now() - 300000),
    battery: 92,
    valves: [
      { id: 'v3', controllerId: '2', channel: 1, name: 'Válvula Principal', status: 'closed' },
    ],
    assignedSensorIds: ['4'],
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-06-10'),
  },
  {
    id: '3',
    name: 'Controlador Entrada',
    model: 'UC512',
    deviceEUI: 'A8404136C1842D60',
    gardenId: '2',
    coordinates: { lat: 40.4295, lng: -3.7025 },
    communicationType: 'chirpstack',
    lnsConfig: {
      serverId: 'lns-2',
    },
    status: 'offline',
    lastSeen: new Date(Date.now() - 86400000),
    battery: 15,
    valves: [
      { id: 'v4', controllerId: '3', channel: 1, name: 'Válvula A', status: 'closed' },
      { id: 'v5', controllerId: '3', channel: 2, name: 'Válvula B', status: 'closed' },
    ],
    assignedSensorIds: ['3'],
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-06-01'),
  },
  {
    id: '4',
    name: 'Controlador Fuente Principal',
    model: 'UC512',
    deviceEUI: 'A8404136C1842D61',
    gardenId: '1',
    coordinates: { lat: 40.4218, lng: -3.6875 },
    communicationType: 'chirpstack',
    lnsConfig: {
      serverId: 'lns-1',
    },
    status: 'online',
    lastSeen: new Date(Date.now() - 60000),
    battery: 78,
    valves: [
      { id: 'v6', controllerId: '4', channel: 1, name: 'Válvula Fuente', status: 'closed' },
      { id: 'v7', controllerId: '4', channel: 2, name: 'Válvula Rocío', status: 'closed' },
    ],
    assignedSensorIds: [],
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-06-12'),
  },
];

export const mockSensors: Sensor[] = [
  {
    id: '1',
    name: 'Sensor Césped Principal',
    model: 'EM500-SMTC',
    deviceEUI: 'B8404136C1842E5A',
    gardenId: '1',
    coordinates: { lat: 40.4225, lng: -3.6892 },
    communicationType: 'chirpstack',
    status: 'online',
    lastSeen: new Date(),
    battery: 78,
    lastReading: {
      id: 'r1',
      sensorId: '1',
      temperature: 24.5,
      humidity: 45,
      conductivity: 120,
      timestamp: new Date(),
    },
    createdAt: new Date('2024-02-05'),
    updatedAt: new Date('2024-06-15'),
  },
  {
    id: '2',
    name: 'Sensor Zona Arbustos',
    model: 'EM500-SMTC',
    deviceEUI: 'B8404136C1842E5B',
    gardenId: '1',
    coordinates: { lat: 40.4218, lng: -3.6885 },
    communicationType: 'mqtt',
    status: 'online',
    lastSeen: new Date(Date.now() - 120000),
    battery: 65,
    lastReading: {
      id: 'r2',
      sensorId: '2',
      temperature: 23.8,
      humidity: 52,
      conductivity: 115,
      timestamp: new Date(Date.now() - 120000),
    },
    createdAt: new Date('2024-02-10'),
    updatedAt: new Date('2024-06-14'),
  },
  {
    id: '3',
    name: 'Sensor Entrada',
    model: 'EM500-SMTC',
    deviceEUI: 'B8404136C1842E5C',
    gardenId: '2',
    coordinates: { lat: 40.4290, lng: -3.7020 },
    communicationType: 'chirpstack',
    status: 'warning',
    lastSeen: new Date(Date.now() - 3600000),
    battery: 22,
    lastReading: {
      id: 'r3',
      sensorId: '3',
      temperature: 28.2,
      humidity: 32,
      conductivity: 98,
      timestamp: new Date(Date.now() - 3600000),
    },
    createdAt: new Date('2024-03-05'),
    updatedAt: new Date('2024-06-10'),
  },
  {
    id: '4',
    name: 'Sensor Rosaleda',
    model: 'EM500-SMTC',
    deviceEUI: 'B8404136C1842E5D',
    gardenId: '1',
    coordinates: { lat: 40.4205, lng: -3.6895 },
    communicationType: 'chirpstack',
    status: 'online',
    lastSeen: new Date(Date.now() - 180000),
    battery: 88,
    lastReading: {
      id: 'r4',
      sensorId: '4',
      temperature: 25.1,
      humidity: 48,
      conductivity: 125,
      timestamp: new Date(Date.now() - 180000),
    },
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-06-14'),
  },
];

export const mockSchedules: Schedule[] = [
  {
    id: '1',
    name: 'Riego Matutino Césped',
    gardenId: '1',
    assignments: [
      { id: 'sa1', controllerId: '1', valveId: 'v1' },
      { id: 'sa2', controllerId: '1', valveId: 'v2' },
    ],
    startTime: '06:30',
    duration: 30,
    daysOfWeek: [1, 2, 3, 4, 5],
    enabled: true,
    createdAt: new Date('2024-03-01'),
    updatedAt: new Date('2024-05-15'),
  },
  {
    id: '2',
    name: 'Riego Nocturno Arbustos',
    gardenId: '1',
    assignments: [
      { id: 'sa3', controllerId: '1', valveId: 'v2' },
    ],
    startTime: '22:00',
    duration: 45,
    daysOfWeek: [0, 2, 4, 6],
    enabled: true,
    createdAt: new Date('2024-03-10'),
    updatedAt: new Date('2024-05-20'),
  },
  {
    id: '3',
    name: 'Riego Rosaleda',
    gardenId: '1',
    assignments: [
      { id: 'sa4', controllerId: '2', valveId: 'v3' },
    ],
    startTime: '07:00',
    duration: 20,
    daysOfWeek: [1, 3, 5],
    enabled: true,
    createdAt: new Date('2024-04-05'),
    updatedAt: new Date('2024-05-25'),
  },
  {
    id: '4',
    name: 'Riego Fin de Semana',
    gardenId: '1',
    assignments: [
      { id: 'sa5', controllerId: '4', valveId: 'v6' },
      { id: 'sa6', controllerId: '4', valveId: 'v7' },
    ],
    startTime: '08:00',
    duration: 60,
    daysOfWeek: [0, 6],
    enabled: false,
    createdAt: new Date('2024-04-15'),
    updatedAt: new Date('2024-06-01'),
  },
];

export const mockTriggers: Trigger[] = [
  {
    id: '1',
    name: 'Riego por humedad baja',
    description: 'Activa riego cuando la humedad del suelo está por debajo del umbral',
    category: 'sensor',
    sensorConfig: {
      sensorType: 'humidity',
      condition: 'lt',
      threshold: 25,
      action: 'start_irrigation',
      irrigationDuration: 15,
    },
    enabled: true,
    zoneAssignments: [
      { id: 'ta1', triggerId: '1', gardenId: '1', zoneId: 'z1', controllerId: '1', valveChannel: 1 },
    ],
    createdAt: new Date('2024-03-20'),
    updatedAt: new Date('2024-05-10'),
  },
  {
    id: '2',
    name: 'Detener por humedad alta',
    description: 'Detiene el riego cuando la humedad supera el umbral',
    category: 'sensor',
    sensorConfig: {
      sensorType: 'humidity',
      condition: 'gt',
      threshold: 75,
      action: 'stop_irrigation',
    },
    enabled: true,
    zoneAssignments: [
      { id: 'ta2', triggerId: '2', gardenId: '1', zoneId: 'z1', controllerId: '1', valveChannel: 1 },
    ],
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-05-15'),
  },
  {
    id: '3',
    name: 'Anular riego por lluvia',
    description: 'Cancela el riego programado si hay previsión de lluvia',
    category: 'forecast',
    forecastConfig: {
      forecastType: 'rain',
      condition: 'rain_probability_gt',
      threshold: 80,
      action: 'cancel_irrigation',
    },
    enabled: true,
    zoneAssignments: [],
    createdAt: new Date('2024-03-15'),
    updatedAt: new Date('2024-05-01'),
  },
  {
    id: '4',
    name: 'Riego extra por calor',
    description: 'Añade riego adicional cuando la temperatura prevista es muy alta',
    category: 'forecast',
    forecastConfig: {
      forecastType: 'temperature',
      condition: 'temperature_gt',
      threshold: 35,
      action: 'add_irrigation',
      irrigationDuration: 20,
    },
    enabled: false,
    zoneAssignments: [],
    createdAt: new Date('2024-04-10'),
    updatedAt: new Date('2024-05-20'),
  },
];

export const mockGardens: Garden[] = [
  {
    id: '1',
    name: 'Parque del Retiro - Zona Norte',
    description: 'Zona norte del Parque del Retiro, incluye el área de césped principal y los jardines de arbustos.',
    companyId: '1',
    municipality: 'Madrid',
    coordinates: { lat: 40.4220, lng: -3.6890 },
    area: 15000,
    zones: [
      { 
        id: 'z1', 
        name: 'Césped Principal', 
        gardenId: '1', 
        controllerAssignments: [
          { id: 'ca1', controllerId: '1', valveChannel: 1, sensorId: '1' },
          { id: 'ca2', controllerId: '1', valveChannel: 2, sensorId: '2' },
        ],
        scheduleAssignments: [
          { id: 'sa1', scheduleId: '1', controllerId: '1', valveChannel: 1 },
        ],
        createdAt: new Date('2024-02-01'), 
        updatedAt: new Date('2024-06-15') 
      },
      { 
        id: 'z2', 
        name: 'Arbustos Norte', 
        gardenId: '1', 
        controllerAssignments: [
          { id: 'ca3', controllerId: '2', valveChannel: 1, sensorId: '4' },
        ],
        scheduleAssignments: [
          { id: 'sa2', scheduleId: '3', controllerId: '2', valveChannel: 1 },
        ],
        createdAt: new Date('2024-02-15'), 
        updatedAt: new Date('2024-06-10') 
      },
      { 
        id: 'z3', 
        name: 'Rosaleda', 
        gardenId: '1', 
        controllerAssignments: [
          { id: 'ca4', controllerId: '4', valveChannel: 1 },
          { id: 'ca5', controllerId: '4', valveChannel: 2 },
        ],
        scheduleAssignments: [],
        createdAt: new Date('2024-04-01'), 
        updatedAt: new Date('2024-06-12') 
      },
    ],
    controllers: mockControllers.filter(c => c.gardenId === '1'),
    sensors: mockSensors.filter(s => s.gardenId === '1'),
    schedules: mockSchedules.filter(s => s.gardenId === '1'),
    triggers: mockTriggers.filter(t => t.zoneAssignments.some(za => za.gardenId === '1')),
    createdAt: new Date('2024-01-20'),
    updatedAt: new Date('2024-06-15'),
  },
  {
    id: '2',
    name: 'Jardín Botánico Entrada',
    description: 'Área de entrada al Jardín Botánico con plantaciones ornamentales.',
    companyId: '1',
    municipality: 'Madrid',
    coordinates: { lat: 40.4292, lng: -3.7022 },
    area: 5000,
    zones: [
      { 
        id: 'z4', 
        name: 'Entrada Principal', 
        gardenId: '2', 
        controllerAssignments: [
          { id: 'ca6', controllerId: '3', valveChannel: 1, sensorId: '3' },
          { id: 'ca7', controllerId: '3', valveChannel: 2 },
        ],
        scheduleAssignments: [],
        createdAt: new Date('2024-03-01'), 
        updatedAt: new Date('2024-06-01') 
      },
    ],
    controllers: mockControllers.filter(c => c.gardenId === '2'),
    sensors: mockSensors.filter(s => s.gardenId === '2'),
    schedules: [],
    triggers: [],
    createdAt: new Date('2024-02-25'),
    updatedAt: new Date('2024-06-01'),
  },
  {
    id: '3',
    name: 'Parque de María Luisa',
    description: 'Jardín histórico con fuentes y zonas verdes en el centro de Sevilla.',
    companyId: '2',
    municipality: 'Sevilla',
    coordinates: { lat: 37.3772, lng: -5.9869 },
    area: 34000,
    zones: [],
    controllers: [],
    sensors: [],
    schedules: [],
    triggers: [],
    createdAt: new Date('2024-03-15'),
    updatedAt: new Date('2024-06-05'),
  },
];

export const mockDashboardStats: DashboardStats = {
  totalGardens: 3,
  totalControllers: 4,
  totalSensors: 4,
  activeIrrigations: 1,
  onlineDevices: 6,
  offlineDevices: 1,
  averageHumidity: 44,
  waterSavedToday: 1850,
};

// Genera datos horarios mock para un día
const generateHourlyData = (baseTemp: number, baseHumidity: number, basePrecipProb: number, isRainy: boolean) => {
  const hours = [];
  for (let h = 0; h < 24; h++) {
    // Temperatura más baja por la noche, más alta al mediodía
    const tempVariation = h < 6 ? -6 : h < 12 ? (h - 6) * 1.5 : h < 18 ? 9 - (h - 12) * 0.8 : -2 - (h - 18) * 0.5;
    const temp = Math.round(baseTemp + tempVariation);
    
    // Probabilidad de lluvia más alta en ciertas horas
    const precipVar = isRainy ? (h >= 14 && h <= 18 ? 30 : 0) : (Math.random() * 10 - 5);
    const precipProb = Math.max(0, Math.min(100, Math.round(basePrecipProb + precipVar)));
    
    hours.push({
      hour: h,
      temperature: temp,
      humidity: Math.round(baseHumidity + (h < 8 ? 15 : h > 20 ? 10 : -5)),
      precipitationProbability: precipProb,
      precipitation: precipProb > 50 ? Math.round(precipProb / 20) : 0,
      windSpeed: Math.round(8 + Math.random() * 10),
      description: precipProb > 60 ? 'Lluvia' : precipProb > 30 ? 'Nublado' : h >= 6 && h <= 20 ? 'Soleado' : 'Despejado',
      icon: precipProb > 50 ? 'cloud-rain' : precipProb > 30 ? 'cloud' : 'sun',
    });
  }
  return hours;
};

export const mockWeatherData: WeatherData[] = [
  {
    municipality: 'Madrid',
    date: new Date(),
    temperature: { min: 18, max: 32 },
    humidity: 45,
    precipitation: 0,
    precipitationProbability: 10,
    windSpeed: 12,
    description: 'Soleado',
    icon: 'sun',
    hourlyData: generateHourlyData(25, 45, 10, false),
  },
  {
    municipality: 'Madrid',
    date: new Date(Date.now() + 86400000),
    temperature: { min: 19, max: 34 },
    humidity: 40,
    precipitation: 0,
    precipitationProbability: 5,
    windSpeed: 8,
    description: 'Despejado',
    icon: 'sun',
    hourlyData: generateHourlyData(27, 40, 5, false),
  },
  {
    municipality: 'Madrid',
    date: new Date(Date.now() + 172800000),
    temperature: { min: 17, max: 28 },
    humidity: 65,
    precipitation: 5,
    precipitationProbability: 60,
    windSpeed: 15,
    description: 'Probabilidad de lluvia',
    icon: 'cloud-rain',
    hourlyData: generateHourlyData(22, 65, 60, true),
  },
  {
    municipality: 'Madrid',
    date: new Date(Date.now() + 259200000),
    temperature: { min: 16, max: 25 },
    humidity: 70,
    precipitation: 8,
    precipitationProbability: 75,
    windSpeed: 18,
    description: 'Lluvioso',
    icon: 'cloud-rain',
  },
  {
    municipality: 'Madrid',
    date: new Date(Date.now() + 345600000),
    temperature: { min: 18, max: 29 },
    humidity: 55,
    precipitation: 0,
    precipitationProbability: 15,
    windSpeed: 10,
    description: 'Parcialmente nublado',
    icon: 'cloud',
  },
  {
    municipality: 'Sevilla',
    date: new Date(),
    temperature: { min: 22, max: 38 },
    humidity: 35,
    precipitation: 0,
    precipitationProbability: 5,
    windSpeed: 8,
    description: 'Muy soleado',
    icon: 'sun',
    hourlyData: generateHourlyData(30, 35, 5, false),
  },
  {
    municipality: 'Sevilla',
    date: new Date(Date.now() + 86400000),
    temperature: { min: 23, max: 39 },
    humidity: 32,
    precipitation: 0,
    precipitationProbability: 3,
    windSpeed: 6,
    description: 'Muy soleado',
    icon: 'sun',
    hourlyData: generateHourlyData(31, 32, 3, false),
  },
];

// Mock irrigation events history
export const mockIrrigationEvents: IrrigationEvent[] = [
  // Today's events
  {
    id: 'ie-1',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'start',
    source: 'schedule',
    sourceId: '1',
    sourceName: 'Riego Matutino Césped',
    timestamp: new Date(new Date().setHours(6, 30, 0, 0)),
    expectedState: 'open',
    actualState: 'open',
  },
  {
    id: 'ie-2',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'stop',
    source: 'schedule',
    sourceId: '1',
    sourceName: 'Riego Matutino Césped',
    timestamp: new Date(new Date().setHours(7, 0, 0, 0)),
    expectedState: 'closed',
    actualState: 'closed',
  },
  {
    id: 'ie-3',
    gardenId: '1',
    zoneId: 'z2',
    controllerId: '2',
    valveChannel: 1,
    eventType: 'start',
    source: 'schedule',
    sourceId: '3',
    sourceName: 'Riego Rosaleda',
    timestamp: new Date(new Date().setHours(7, 0, 0, 0)),
    expectedState: 'open',
    actualState: 'open',
  },
  {
    id: 'ie-4',
    gardenId: '1',
    zoneId: 'z2',
    controllerId: '2',
    valveChannel: 1,
    eventType: 'stop',
    source: 'schedule',
    sourceId: '3',
    sourceName: 'Riego Rosaleda',
    timestamp: new Date(new Date().setHours(7, 20, 0, 0)),
    expectedState: 'closed',
    actualState: 'closed',
  },
  // Yesterday's events
  {
    id: 'ie-5',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'start',
    source: 'schedule',
    sourceId: '1',
    sourceName: 'Riego Matutino Césped',
    timestamp: new Date(Date.now() - 86400000 + 6.5 * 3600000),
    expectedState: 'open',
    actualState: 'open',
  },
  {
    id: 'ie-6',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'stop',
    source: 'schedule',
    sourceId: '1',
    sourceName: 'Riego Matutino Césped',
    timestamp: new Date(Date.now() - 86400000 + 7 * 3600000),
    expectedState: 'closed',
    actualState: 'closed',
  },
  {
    id: 'ie-7',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 2,
    eventType: 'start',
    source: 'schedule',
    sourceId: '2',
    sourceName: 'Riego Nocturno Arbustos',
    timestamp: new Date(Date.now() - 86400000 + 22 * 3600000),
    expectedState: 'open',
    actualState: 'open',
  },
  {
    id: 'ie-8',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 2,
    eventType: 'stop',
    source: 'schedule',
    sourceId: '2',
    sourceName: 'Riego Nocturno Arbustos',
    timestamp: new Date(Date.now() - 86400000 + 22.75 * 3600000),
    expectedState: 'closed',
    actualState: 'closed',
  },
  // Trigger events
  {
    id: 'ie-9',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'start',
    source: 'trigger',
    sourceId: '1',
    sourceName: 'Riego por humedad baja',
    timestamp: new Date(Date.now() - 2 * 86400000 + 14 * 3600000),
    expectedState: 'open',
    actualState: 'open',
    notes: 'Humedad detectada: 22%',
  },
  {
    id: 'ie-10',
    gardenId: '1',
    zoneId: 'z1',
    controllerId: '1',
    valveChannel: 1,
    eventType: 'stop',
    source: 'trigger',
    sourceId: '1',
    sourceName: 'Riego por humedad baja',
    timestamp: new Date(Date.now() - 2 * 86400000 + 14.25 * 3600000),
    expectedState: 'closed',
    actualState: 'closed',
    notes: 'Riego de emergencia completado (15 min)',
  },
  // Event with mismatch
  {
    id: 'ie-11',
    gardenId: '1',
    zoneId: 'z3',
    controllerId: '4',
    valveChannel: 1,
    eventType: 'start',
    source: 'manual',
    sourceName: 'Activación manual',
    timestamp: new Date(Date.now() - 3 * 86400000 + 10 * 3600000),
    expectedState: 'open',
    actualState: 'open',
  },
  {
    id: 'ie-12',
    gardenId: '1',
    zoneId: 'z3',
    controllerId: '4',
    valveChannel: 1,
    eventType: 'stop',
    source: 'manual',
    sourceName: 'Desactivación manual',
    timestamp: new Date(Date.now() - 3 * 86400000 + 10.5 * 3600000),
    expectedState: 'closed',
    actualState: 'closed',
  },
  // State mismatch example (for alert)
  {
    id: 'ie-13',
    gardenId: '2',
    zoneId: 'z4',
    controllerId: '3',
    valveChannel: 1,
    eventType: 'start',
    source: 'schedule',
    sourceId: '5',
    sourceName: 'Riego Programado',
    timestamp: new Date(Date.now() - 86400000 + 8 * 3600000),
    expectedState: 'open',
    actualState: 'closed',
    notes: 'Error: Controlador sin respuesta',
  },
];
